import React from 'react';

import { IFormFieldInputBaseProps } from '@components/form-fields';
import { Paper } from '@mui/material';
import { MAIN_THEME } from '@styles';

import clsx from 'clsx';
import { makeStyles } from 'tss-react/mui';

interface IWidgetPaperProps extends IFormFieldInputBaseProps {
  classes?: { paper?: string };
  children?: React.ReactNode;
}

const useStyles = makeStyles()(() => ({
  paper: {
    padding: '15px 25px',
    boxSizing: 'border-box',
    width: 'calc(100% - 6px)',
    boxShadow: `0px 0px 6px ${MAIN_THEME.color.white86}`,
    margin: '3px auto'
  }
}));

const WidgetPaper: React.FC<IWidgetPaperProps> = ({
  classes = {},
  className,
  style,
  children
}) => {
  const { classes: paperClasses } = useStyles();

  return (
    <Paper
      className={clsx(paperClasses.paper, classes.paper, className)}
      style={style}
    >
      {children}
    </Paper>
  );
};

export default WidgetPaper;
